import { GameView, type GameViewOptions } from './game/GameView';
import { preloadCarModels } from './game/Car';
import { runEntityInterpolationSelfTest } from './net/entityInterpolation';
import { initLobby } from './ui/LobbyClient';
import { LobbyAmbient } from './audio/LobbyAmbient';
import { LobbyPreview } from './lobby/LobbyPreview';

if (import.meta.env.DEV) {
  runEntityInterpolationSelfTest();
}

const appEl = document.getElementById('app');
if (!appEl) {
  throw new Error('Missing #app');
}
const appRoot: HTMLElement = appEl;

let gameView: GameView | null = null;
let lobbyAmbient: LobbyAmbient | null = null;
let lobbyPreview: LobbyPreview | null = null;

function teardownLobbyPremium(): void {
  lobbyAmbient?.dispose();
  lobbyAmbient = null;
  lobbyPreview?.dispose();
  lobbyPreview = null;
}

function startGame(options?: GameViewOptions): void {
  if (gameView) return;
  gameView = new GameView(appRoot, options);
}

const predMode =
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('pred') === '1';

void (async () => {
  console.info('[Last Mile] Preloading vehicles…');
  await preloadCarModels();
  console.info('[Last Mile] Vehicles ready.');

  if (predMode) {
    document.body.classList.remove('lobby-active');
    const lobby = document.getElementById('lobby-screen');
    if (lobby) lobby.hidden = true;
    startGame();
  } else {
    lobbyAmbient = new LobbyAmbient();
    lobbyPreview = new LobbyPreview(
      document.getElementById('lobby-preview'),
    );
    initLobby({
      onQuickPlay: () => {
        try {
          sessionStorage.setItem('lm-atmosphere', 'storm');
        } catch {
          /* ignore */
        }
        teardownLobbyPremium();
        startGame();
      },
      onGameStart: (info) => {
        teardownLobbyPremium();
        document.body.dataset.mpRole = info.role;
        document.body.dataset.mpSession = info.sessionId;
        document.body.dataset.mpSeed = String(info.seed);
        document.body.dataset.mpRoom = info.roomCode;
        startGame({
          multiplayer: {
            room: info.room,
            role: info.role,
            sessionId: info.sessionId,
            seed: info.seed,
            roomCode: info.roomCode,
          },
        });
      },
    });
  }
})().catch(console.error);

window.addEventListener('beforeunload', () => {
  gameView?.dispose();
});
